import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organizationName: "",
  organizationAdminUserName: "",
  organizationEmail: "",
  password: "",
  confirmPassword: "",
  organizationId: "",
  isBillingPopupOpen: false,
  activeSection: "details-section",
  file: null,
};

const onboardSlice = createSlice({
  name: "onboard",
  initialState,
  reducers: {
    setOrganizationName: (state, action) => {
      state.organizationName = action.payload;
    },
    setOrganizationAdminUserName: (state, action) => {
      state.organizationAdminUserName = action.payload;
    },
    setOrganizationEmail: (state, action) => {
      state.organizationEmail = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
    },
    setConfirmPassword: (state, action) => {
      state.confirmPassword = action.payload;
    },
    setOrganizationId: (state, action) => {
      state.organizationId = action.payload;
    },
    setIsBillingPopupOpen: (state, action) => {
      state.isBillingPopupOpen = action.payload;
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    setFile: (state, action) => {
      state.file = action.payload;
    },
    resetOnboardState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const onboardActions = onboardSlice.actions;
export default onboardSlice;
